import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { ComponentFunction } from "@glidejs/glide";
import Glide from "@glidejs/glide";

@ModuleName("RetailMain")
export class RetailMain implements AxInit {
    private Glides: Map<string, Glide.Static> = new Map<string, Glide.Static>();

    AxInit(init: any): void {
        $('.ax-products__groupList[data-display-mode="swiper"]').each((i, x) => {
            let glideID: string = $(x).attr('id');
            let rows: number = $(x).data('rows');
            let smallGap = $(x).hasClass('glid--sm');
            let glide = new Glide('#' + glideID, {
                type: 'slider',
                perView: rows,
                rewind: false,
                bound: true,
                animationDuration: 300,
                breakpoints: {
                    800: {
                        perView: 2
                    },
                    480: {
                        perView: 1
                    }
                },
                classes: {
                    activeSlide: 'glide__slide--active',
                    disabledArrow: 'glide__arrow--disabled'
                },
                gap: smallGap ? -18 : 0
            });

            this.Glides.set(glideID, glide);

            glide.on('run.before', e => {
                e.steps = e.direction === '>' ? -glide.settings.perView : glide.settings.perView
            })
            glide.mount({
                'DisableControls': this.updateGlideFunc
            });
        });
    }

    private updateGlideFunc: ComponentFunction = (glide: Glide.Static, Components: any, Events: any) => {

        const PREV_CONTROL_SELECTOR = "[data-glide-dir='<']";
        const NEXT_CONTROL_SELECTOR = "[data-glide-dir='>']";
        const component = {
            buildAfter() {
                this.prevBtn = Components.Html.root.querySelector(PREV_CONTROL_SELECTOR);
                this.nextBtn = Components.Html.root.querySelector(NEXT_CONTROL_SELECTOR);
            },
            handleDisable() {
                const perView = glide.settings.perView;
                const slidesCount = Components.Html.slides.length;

                this.prevBtn.disabled = (glide.index <= 0);
                this.nextBtn.disabled = (glide.index >= slidesCount - perView);
            },
            mount() {
            }
        };

        Events.on("build.after", function () {
            component.buildAfter();
            component.handleDisable();
        });
        Events.on("run.after", function () {
            component.handleDisable();
        });
        return component;
    }
}